import * as React from "react";
const SellCircleLogoSvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.iconWidth}
    height={props.iconHeight}
    x={props.iconX}
    y={props.iconY}
    style={{
      height: `${props.height || 160}`,
      // top: "61%",
      // position: "absolute",
      // right: "10%",
    }}
    className="responsive-svg"
    viewBox="0 0 223 223"
    {...props}
  >
    <g transform={"rotate(0, 111.5, 111.5)"}>
      <circle cx={111.5} cy={111.5} r={111} fill="#fff" stroke="#118BF4" />
      <circle cx={111.5} cy={111.5} r={101.317} fill="#254A72" />
      <g clipPath="url(#a)">
        <path
          fill="#118BF4"
          d="M147.836 90.687H67.924a1.742 1.742 0 0 1-1.737-1.737c0-.955.782-1.737 1.737-1.737h79.912c.956 0 1.738.782 1.738 1.737 0 .956-.782 1.737-1.738 1.737Z"
        />
        <path
          fill="#fff"
          d="M74.873 83.739c-.104 0-.225 0-.33-.035-.121 0-.226-.052-.33-.104a1.317 1.317 0 0 1-.312-.157c-.087-.052-.174-.139-.261-.208A1.827 1.827 0 0 1 73.136 82c0-.451.191-.903.504-1.233l.26-.209c.105-.07.21-.121.313-.156a1.05 1.05 0 0 1 .33-.104c.556-.122 1.147.07 1.564.469.313.33.504.782.504 1.233 0 .452-.191.904-.504 1.234-.33.312-.782.504-1.234.504ZM81.822 83.739c-.451 0-.903-.192-1.233-.504A1.827 1.827 0 0 1 80.085 82c0-.451.191-.903.504-1.233.66-.643 1.824-.643 2.467 0 .312.33.503.782.503 1.233 0 .452-.19.904-.503 1.234-.33.312-.782.504-1.234.504ZM88.771 83.739c-.451 0-.903-.192-1.233-.504l-.209-.26a1.317 1.317 0 0 1-.156-.314 1.106 1.106 0 0 1-.104-.312c-.018-.122-.035-.226-.035-.348 0-.451.191-.903.504-1.233.66-.643 1.806-.643 2.467 0 .312.33.503.782.503 1.233 0 .122-.017.226-.034.348a1.102 1.102 0 0 1-.105.312 1.317 1.317 0 0 1-.156.313c-.052.087-.139.174-.208.26-.33.313-.782.505-1.234.505Z"
        />
        <path
          fill="#118BF4"
          d="M147.836 149.753H74.873c-4.794 0-8.686-3.892-8.686-8.686V82.001c0-4.794 3.892-8.686 8.686-8.686h72.963a8.689 8.689 0 0 1 8.686 8.686v59.066c0 4.794-3.891 8.686-8.686 8.686ZM74.873 76.79c-2.866 0-5.211 2.345-5.211 5.211v59.066c0 2.866 2.345 5.211 5.211 5.211h72.963c2.867 0 5.212-2.345 5.212-5.211V82.001c0-2.866-2.345-5.211-5.212-5.211H74.873Z"
        />
        <path
          fill="#fff"
          d="M132.202 139.329h-.018a1.703 1.703 0 0 1-1.598-1.129l-5.212-13.898a1.725 1.725 0 0 1 .4-1.841 1.727 1.727 0 0 1 1.841-.4l13.898 5.212a1.726 1.726 0 0 1 1.129 1.598c0 .713-.417 1.373-1.077 1.633l-3.752 1.529 4.325 4.326a1.729 1.729 0 0 1 0 2.449 1.729 1.729 0 0 1-2.449 0l-4.326-4.325-1.528 3.752a1.723 1.723 0 0 1-1.616 1.077l-.017.017Zm-2.241-12.664 2.31 6.15.834-2.05s.017-.052.035-.087a1.8 1.8 0 0 1 .834-.851l.052-.035 2.05-.834-6.15-2.31.035.017ZM144.362 108.06h-20.847a1.743 1.743 0 0 1-1.737-1.738c0-.955.782-1.737 1.737-1.737h20.847c.955 0 1.737.782 1.737 1.737 0 .956-.782 1.738-1.737 1.738ZM137.413 101.111h-13.898a1.743 1.743 0 0 1-1.737-1.738c0-.955.782-1.737 1.737-1.737h13.898c.955 0 1.737.782 1.737 1.737 0 .956-.782 1.738-1.737 1.738ZM144.362 115.008h-20.847a1.742 1.742 0 0 1-1.737-1.737c0-.955.782-1.737 1.737-1.737h20.847c.955 0 1.737.782 1.737 1.737 0 .956-.782 1.737-1.737 1.737ZM109.618 139.329H85.297a3.484 3.484 0 0 1-3.475-3.474v-12.161c0-.955.782-1.737 1.737-1.737.956 0 1.738.782 1.738 1.737v12.161h24.321v-12.161c0-.955.781-1.737 1.737-1.737.955 0 1.737.782 1.737 1.737v12.161a3.484 3.484 0 0 1-3.474 3.474Z"
        />
        <path
          fill="#fff"
          d="M111.355 125.432c-.452 0-.886-.174-1.234-.504l-12.664-12.664-12.664 12.664a1.731 1.731 0 0 1-2.45 0l-5.211-5.212a1.73 1.73 0 0 1 0-2.449l19.109-19.11a1.73 1.73 0 0 1 2.45 0l19.109 19.11a1.73 1.73 0 0 1 0 2.449l-5.212 5.212a1.706 1.706 0 0 1-1.233.504ZM97.457 108.06c.452 0 .886.173 1.234.503l12.664 12.665 2.762-2.763-16.66-16.659-16.66 16.659 2.762 2.763 12.665-12.665a1.707 1.707 0 0 1 1.233-.503Z"
        />
        <path
          fill="#fff"
          d="M100.932 139.329a1.742 1.742 0 0 1-1.737-1.737v-12.16H95.72v12.16c0 .956-.782 1.737-1.737 1.737a1.742 1.742 0 0 1-1.737-1.737v-13.898c0-.955.781-1.737 1.737-1.737h6.949c.955 0 1.737.782 1.737 1.737v13.898c0 .956-.782 1.737-1.737 1.737Z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M66.187 73.315h90.335v76.438H66.187z" />
      </clipPath>
    </defs>
  </svg>
);
export default SellCircleLogoSvg;
